import * as Sentry from "@sentry/react";

import { useEffect, useState } from "react";
import { useTV } from "../../hooks/useTV";

const HalfTrainAnimation = ({ refresh, animation, trainSoundRef }) => {
  const { isTv } = useTV();
  const [train, setTrain] = useState(true);
  //   const trainSoundRef = useRef();

  const mp3Files = [
    "https://cdn.mywaitserver.live/door1.mp3",
    "https://cdn.mywaitserver.live/door2.mp3",
    "https://cdn.mywaitserver.live/door3.mp3",
    "https://cdn.mywaitserver.live/door4.mp3",
    "https://cdn.mywaitserver.live/door5.mp3",
    "https://cdn.mywaitserver.live/door6.mp3",
  ];

  const getRandomMp3 = () => {
    return mp3Files[Math.floor(Math.random() * mp3Files.length)];
  };

  useEffect(() => {
    if (animation) {
      setTimeout(() => {
        setTrain(false);
      }, 5000);
    }
  }, [refresh]);

  useEffect(() => {
    if (trainSoundRef.current) {
      try {
        trainSoundRef.current.volume = localStorage.getItem("volume");
        trainSoundRef.current.src = getRandomMp3(); // Set a random MP3 file
        trainSoundRef.current.play();
      } catch (e) {
        Sentry.captureException(e);
      }
    }
  }, []);

  return (
    <div>
      {/* <audio ref={trainSoundRef}></audio> */}
      <div
        style={{
          width: "50vw",
          left: !train ? "-50vw" : "0",
          height: "100vh",
          background: "black",
          position: "absolute",
          top: "0%",
          zIndex: "500",
          transition: "all 3s",
        }}
      >
        <img src={isTv ? "https://cdn.mywaitserver.live/door-left-tv.png" : "/static/door-left.png"} alt="" style={{ width: "100%" }} />
      </div>
      <div
        style={{
          width: "50vw",
          right: !train ? "-50vw" : "0",
          height: "100vh",
          background: "black",
          position: "absolute",
          top: "0%",
          zIndex: "500",
          transition: "all 3s",
        }}
      >
        <img src={isTv ? "https://cdn.mywaitserver.live/door-right-tv.png" : "/static/door-right.png"} alt="" style={{ width: "100%" }} />
      </div>
    </div>
  );
};

export default HalfTrainAnimation;
